export const mru = <T>(
  newItem: T,
  items: T[],
  count: number,
  isEqual: (a: T, b: T) => boolean = (a, b) => a === b,
): T[] => {
  return [newItem]
    .concat(items.filter((item) => !isEqual(item, newItem)))
    .slice(0, count);
};

// https://stackoverflow.com/questions/43118692/typescript-filter-out-nulls-from-an-array
export const notNullOrUndefined = <TValue>(
  value: TValue | null | undefined,
): value is TValue => {
  return value !== null && value !== undefined;
};

// Order-independent equality for two lists of ids/keys. Same length and same
// members (as a set) compare equal.
export function sameSet(a: string[], b: string[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const setB = new Set(b);
  return a.every((x) => setB.has(x));
}

export function wrap<T>(value: T | T[] | undefined) {
  if (typeof value === "undefined") {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
